import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ChangeOrderModel, DataTablesResponse } from '../models/common';
import { CupraModelVersionModel } from '../models/cupramodelversion';


@Injectable({
  providedIn: 'root'
})

export class CupraModelVersionService {

  private pathAPI = environment.urlAPI;
  private controller = "CupraModelVersion/";

  constructor(private http: HttpClient) { }

  public searchData(data: any, idModel: string): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/' + idModel, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public post(data: any): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: any): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public get(id: string): Observable<CupraModelVersionModel> {
    return this.http.get<CupraModelVersionModel>(this.pathAPI + this.controller + id);
  }

  public getAllActive(idModel: string): Observable<CupraModelVersionModel[]> {
    return this.http.get<CupraModelVersionModel[]>(this.pathAPI + this.controller + 'GetAllActive/' + idModel);
  }

  public getAllVersions(idModel: string): Observable<CupraModelVersionModel[]> {
    return this.http.get<CupraModelVersionModel[]>(this.pathAPI + this.controller + 'GetAllVersions/' + idModel);
  }

  public searchDataOrder(data: any, idModel: string, idMotorType: number): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableOrder/' + idModel + '/' + idMotorType, data);
  }

  public changeOrder(data: ChangeOrderModel[]): any {
    return this.http.post<any>(this.pathAPI + this.controller + 'ChangeOrder', data);
  }

}
